export enum CurrentAccountType {
    Credit,
    Debt,
    Flat
}


// WEBPACK FOOTER //
// ./src/app/models/CurrentAccountType.ts